import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface AuditLogDto {
  id: string;
  userId: string;
  action: string;
  entity: string;
  entityId: string;
  changes: unknown;
  ipAddress: string | null;
  createdAt: string;
}

export interface PaginatedAudit {
  data: AuditLogDto[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

interface AuditFilters {
  entity?: string;
  userId?: string;
  entityId?: string;
  page?: number;
  limit?: number;
}

const QK = {
  list: (filters: AuditFilters) => ['audit', filters] as const,
};

export function useAuditLogs(filters: AuditFilters = {}) {
  return useQuery({
    queryKey: QK.list(filters),
    queryFn: async () => {
      const params: Record<string, string | number> = {};
      if (filters.entity) params.entity = filters.entity;
      if (filters.userId) params.userId = filters.userId;
      if (filters.entityId) params.entityId = filters.entityId;
      if (filters.page) params.page = filters.page;
      if (filters.limit) params.limit = filters.limit;
      const res = await apiClient.get<PaginatedAudit>('/audit/logs', { params });
      return res.data;
    },
  });
}
